export default "__VITE_ASSET__336ba897__"